import axios from 'axios';
import {
    GET_PRODUCT_AND_SERVICE_DATA,
    ERROR_GET_PRODUCT_AND_SERVICE_DATA,
} from '../types';

export const getProductsAndServices = (apiUrl) => async (dispatch) => {
  try {
    const res = await axios.get(apiUrl);
    dispatch({
      type: GET_PRODUCT_AND_SERVICE_DATA,
      payload: res.data,
    });
  } catch (error) {
    dispatch({
      type: ERROR_GET_PRODUCT_AND_SERVICE_DATA,
      payload: error,
    });
  }
};